import React, { useState, useEffect } from "react";
import Loginbg from "../../assets/images/Login/login-bg.jpg";
import Logo from "../../assets/images/logo/Logo.png";
import './Login.css';
import { loginApi } from "../../Api/auth";
// import Modal from "react-bootstrap/Modal";
// import Form from "react-bootstrap/Form";
import { NotificationContainer } from "react-notifications";
import { notify } from "../../utils/notify";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // const [showChangePassword, setShowChangePassword] = useState(false);
  // const [changeEmail, setChangeEmail] = useState("");
  // const [oldPassword, setOldPassword] = useState("");
  // const [newPassword, setNewPassword] = useState("");
  // const [confirmPassword, setConfirmPassword] = useState("");
  // const [validated, setValidated] = useState(false);
  // const [submitting, setSubmitting] = useState(false);

  // const resetChangePasswordForm = () => {
  //   setChangeEmail("");
  //   setOldPassword("");
  //   setNewPassword("");
  //   setConfirmPassword("");
  //   setValidated(false);
  // };

  // const handleCloseChangePassword = () => {
  //   resetChangePasswordForm();
  //   setShowChangePassword(false);
  // };

  // const handleShowChangePassword = () => {
  //   resetChangePasswordForm();
  //   setShowChangePassword(true);
  // };

    const handelSubmit = () => {
        const formData = new FormData();
        formData.append("email", email);
        formData.append("password", password);

        if(email === "" || password === ""){
            notify.warning("Please enter email and password");
            return;
        }

       loginApi(formData).then((response) => {
        if (response.code === 200) {
            if(response.data.status == 0){
                notify.error(response.data.message);
                return;
            }
            else{
                localStorage.setItem("user", JSON.stringify(response.data.data));
                localStorage.setItem("token", response.data.data.token);
                window.location.href = "/dashboard";
            }
        }
        }).catch((error) => {
            notify.error(error);
        });
    }

  // const handleChangePasswordSubmit = (event) => {
  //   event.preventDefault();
  //   event.stopPropagation();

  //   const form = event.currentTarget;
  //   const passwordsMatch = newPassword === confirmPassword;

  //   setValidated(true);

  //   if (form.checkValidity() === false || !passwordsMatch) {
  //     if (!passwordsMatch && confirmPassword) {
  //       notify.error("New password and confirm password do not match");
  //     }
  //     return;
  //   }

  //   setSubmitting(true);
  //   const formData = new FormData();
  //   formData.append("email", changeEmail.trim());
  //   formData.append("oldpassword", oldPassword);
  //   formData.append("newpassword", newPassword);
  //   formData.append("confirmpassword", confirmPassword);

  //   changeAdminPassword(formData)
  //     .then((response) => {
  //       if (response.code === 200) {
  //         if (
  //           response.data?.status == 0 ||
  //           response.data?.status === "0" ||
  //           response.data?.status === "error"
  //         ) {
  //           notify.error(response.data?.message || "Unable to change password");
  //           return;
  //         }
  //         notify.success(response.data?.message || "Password updated successfully");
  //         handleCloseChangePassword();
  //       } else {
  //         notify.error(response.data?.message || "Something went wrong");
  //       }
  //     })
  //     .catch((error) => {
  //       notify.error(error?.message || "Something went wrong");
  //     })
  //     .finally(() => {
  //       setSubmitting(false);
  //     });
  // };

    useEffect(() => {   
        if (localStorage.getItem("user") != null) {
            window.location.href = "/dashboard";
        }
    }, []);

    

    return (
        <div className="Login">
            <section className="vh-100" style={{ backgroundColor: '#9A616D' }}>
                <div className="container py-5 h-100">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col col-xl-12">
                            <div className="card" style={{ borderRadius: '1rem' }}>
                                <div className="row g-0">
                                    <div className="col-md-6 col-lg-6 d-none d-md-block">
                                        <img src={Loginbg}
                                            alt="login form" className="img-fluid" style={{ borderRadius: '1rem 0 0 1rem' }} />
                                    </div>
                                    <div className="col-md-6 col-lg-6 d-flex align-items-center">
                                        <div className="card-body p-4 p-lg-5 text-black">
                                            <form id="loginform" 
                                            // ref={formRef}
                                            >
                                                <div className="d-flex align-items-center mb-3 pb-1">
                                                    {/* <i className="fas fa-cubes fa-2x me-3" style="color: #ff6219;"></i> */}
                                                    <span className="h1 fw-bold mb-0"><img src={Logo} alt="logo" className="logo-icon" /></span>
                                                </div>

                                                <h3 className=" login-head" style={{ letterSpacing: '1px' }}>Welcome to <span className="color-text">Green Frog!</span> 👋</h3>

                                                <h5 className="fw-normal mb-3 pb-3" style={{ letterSpacing: '1px' }}>Please sign in to your account and start the adventure</h5>

                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="form2Example17">Email address</label>
                                                    <input type="email" id="email" name="email" onChange={
                                                        (e) => {
                                                            setEmail(e.target.value);
                                                        }
                                                    }  className="form-control form-control-lg" />
                                                </div>

                                                <div className="form-outline mb-4">
                                                    <label className="form-label" htmlFor="form2Example27">Password</label>
                                                    <input type="password" id="password" name="password" onChange={
                                                        (e) => {
                                                            setPassword(e.target.value);
                                                        }
                                                    } className="form-control form-control-lg" />
                                                </div>

                                                <div className="pt-1 mb-4">
                                                    {/* <Link to="/" className="btn custom-login-btn btn-lg btn-block" type="button">Sign In</Link> */}
                                                    <button type="button" className="btn custom-login-btn btn-lg btn-block"
                                                    onClick={() => {
                                                          handelSubmit() 
                                                    }}
                                                    >Sign In</button>
                                                </div>
                                                {/* <div className="text-center">
                          <button
                            type="button"
                            className="change-password-link"
                            onClick={handleShowChangePassword}
                          >
                            Change Password
                          </button>
                        </div> */}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <Modal show={showChangePassword} onHide={handleCloseChangePassword} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custum-modal-body">
          <Form noValidate validated={validated} onSubmit={handleChangePasswordSubmit}>
            <Form.Group className="mb-3" controlId="changePasswordEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                type="email"
                value={changeEmail}
                onChange={(e) => setChangeEmail(e.target.value)}
                placeholder="Enter email"
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid email.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="changePasswordOld">
              <Form.Label>Old Password</Form.Label>
              <Form.Control
                required
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                placeholder="Enter old password"
              />
              <Form.Control.Feedback type="invalid">
                Please provide old password.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="changePasswordNew">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                required
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
              />
              <Form.Control.Feedback type="invalid">
                Please provide new password.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="changePasswordConfirm">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                required
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                isInvalid={validated && confirmPassword !== newPassword}
              />
              <Form.Control.Feedback type="invalid">
                {confirmPassword && confirmPassword !== newPassword
                  ? "New password and confirm password do not match."
                  : "Please confirm new password."}
              </Form.Control.Feedback>
            </Form.Group>

            <div className="modal-btn d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn Cancel-bttn"
                onClick={handleCloseChangePassword}
              >
                Cancel
              </button>
              <button type="submit" className="btn Active-bttn" disabled={submitting}>
                {submitting ? "Updating..." : "Update Password"}
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal> */}

      <NotificationContainer />
    </div>
  );
};


export default Login;